import { service } from '@ember/service';
import Controller from '@ember/controller';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { getOwner } from '@ember/application';
import { isTesting, macroCondition } from '@embroider/macros';

const WIDE_PAGE_ROUTES = ['jem', 'oee', 'workInstructions'];
const NO_CHROME_ROUTES = ['jem', 'oee'];

export default class ApplicationController extends Controller {
  @tracked isLoading = false;
  @tracked showLogoutWarningModal = false;
  #authToken;

  @service session;
  @service router;
  @service resizeListener;
  @service notifier;
  @service webSocket;
  @service licensing;

  // eslint-disable-next-line no-unneeded-ternary
  isTesting = macroCondition(isTesting()) ? true : false;

  get isIntegrationTesting() {
    return globalThis.isIntegrationTest;
  }

  get onWidePageLayout() {
    if (this.router.currentRouteName === 'workInstructions.index') {
      return false;
    }
    return WIDE_PAGE_ROUTES.some((route) => this.router.currentRouteName.startsWith(route));
  }

  get noChrome() {
    return NO_CHROME_ROUTES.some((route) => this.router.currentRouteName.startsWith(route));
  }

  get onBiPage() {
    return this.router.currentRouteName.startsWith('bi');
  }

  @action
  confirmLogoutWarning() {
    this.showLogoutWarningModal = false;
    getOwner(this).lookup('authenticator:jwt').refreshAccessToken(this.#authToken);
    this.#authToken = null;
    this.notifier.sendWarning('logoutModal.extendNotification');
  }

  @action
  logout() {
    this.showLogoutWarningModal = false;
    return this.session.invalidate();
  }

  onCloseLogoutWarningModal() {
    if (!this.showLogoutWarningModal) {
      return;
    }

    this.showLogoutWarningModal = false;
    this.#authToken = null;
  }

  onShowLogoutWarningModal(token) {
    if (this.showLogoutWarningModal) {
      return;
    }

    this.#authToken = token;
    this.showLogoutWarningModal = true;
  }
}
